<script setup lang="ts">
/**
 * 多行文本骨架。
 *
 * 最后一行是 `w-2/3`：等宽的灰条读起来像一个表格，
 * 参差的行尾才像一段文字，视觉上更接近"这里将出现一段话"。
 */

import { cn } from '../../lib/cn';
import Skeleton from './Skeleton.vue';

const props = withDefaults(defineProps<{ lines?: number; className?: string }>(), { lines: 3 });
</script>

<template>
  <div :class="cn('flex flex-col gap-2', props.className)">
    <Skeleton
      v-for="index in props.lines"
      :key="index"
      :class="cn('h-3.5', index === props.lines ? 'w-2/3' : 'w-full')"
    />
  </div>
</template>
